import { ImpactType } from '../impact';
import Decimal from 'decimal.js';

export type ImpactTypeTotals = {
  [key in ImpactType]?: Decimal;
};

export type ImpactOrderReportPeriod = {
  periodStart: string;
  periodEnd: string;
  pending: ImpactTypeTotals;
  paid: ImpactTypeTotals;
};
